import { stores } from '../../stores';
import { getStoreValue } from '../../stores/store/utils';
import some from 'lodash/some';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import { LocalStorage } from '../local-storage/types';
import { storageGet } from '../storage';
import { isMobile } from '../browser';
import { removeAllNonFrontendErrors } from './betslip';

export const checkIsOpenbetValidCombo = () => {
    const version = storageGet(LocalStorage.BETBUILDER_VERSION);
    const storeName = version === 'v1' ? 'customBetbuilder' : 'customBetbuilderV2';

    const errors = version === 'v1' ? 'betbuilderErrorsByMatchId' : 'betSlipErrorByMarketId';
    const errorsById: Record<string, any[]> = getStoreValue(stores.sports[storeName][errors]);
    const comboHasErroneousMarket = Object.values(errorsById).some((errors) => errors.length);

    const redundantMarketIdsByMatchId = getStoreValue(stores.sports[storeName].betbuilderRedundantMarketIdsByMatchId);
    const comboHasRedundantMarket = some(Object.values(redundantMarketIdsByMatchId), (selections) => {
        const areMarketsNotCombinable = selections === null;
        const isThereRedundantMarket = selections?.length;
        return areMarketsNotCombinable || isThereRedundantMarket;
    });

    let comboHasOneSelectionMarket = false;
    if (version === 'v2') {
        const marketSelectionsByFixtureId = getStoreValue(stores.sports.customBetbuilderV2.selectedOutcomesByFixtureId);
        comboHasOneSelectionMarket = some(
            Object.values(marketSelectionsByFixtureId),
            (selectionIdByMarketId) => Object.keys(selectionIdByMarketId).length < 2,
        );
    }
    return !comboHasRedundantMarket && !comboHasErroneousMarket && !comboHasOneSelectionMarket;
};

export const removeOpenbetMarketByFixtureId = (fixtureId: string, marketId: string) => {
    stores.sports.customBetbuilderV2.selectedOutcomesByFixtureId.set((state) => {
        const currentState = { ...state };
        const updatedSelectionsByMarketId = omit(currentState[fixtureId], marketId);
        const isNotEmpty = !isEmpty(updatedSelectionsByMarketId);
        if (isNotEmpty) {
            return { ...currentState, [fixtureId]: updatedSelectionsByMarketId };
        }
        return omit(currentState, fixtureId);
    });
};

export const removeCoreMarketFromBetslip = (marketId: number) => {
    const { isLoading } = getStoreValue(stores.sports.betSlipPlacingState);
    const betSlipMarketIdToOutcomeId = getStoreValue(stores.sports.betSlipMarketIdToOutcomeId);
    if (isLoading) {
        return;
    }
    removeAllNonFrontendErrors();
    stores.sports.betSlipMarketIdToOutcomeId.set((state) => omit(state, marketId));
    stores.sports.marketInfoById.set((state) => omit(state, marketId));
    const isMarketIdToOutcomeIdEmpty = Object.entries(betSlipMarketIdToOutcomeId).length === 0;
    if (isMarketIdToOutcomeIdEmpty && isMobile()) {
        stores.isBetslipOpen.set(false);
    }
};
